import { render, staticRenderFns } from "./LoginTabs.vue?vue&type=template&id=217f15fc&scoped=true"
import script from "./LoginTabs.vue?vue&type=script&lang=js"
export * from "./LoginTabs.vue?vue&type=script&lang=js"
import style0 from "./LoginTabs.vue?vue&type=style&index=0&id=217f15fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f15fc",
  null
  
)

export default component.exports